import type { GraphData } from "../types/gameTypes";
import { generatePair } from "./pairGenerator";

/**
 * Pick a start/target pair with par 3-6 (best-route hops; see pairGenerator for
 * the method and difficulty mix). Deterministic for a given `rng`; never returns
 * an ordered pair in `exclude`. Returns nulls only when no reachable pair exists.
 */
export const findValidWordPair = (
  graphData: GraphData | null,
  opts: { rng?: () => number; exclude?: Set<string>; par?: number } = {},
): { start: string | null; end: string | null } => {
  const pair = generatePair(graphData, opts);
  if (!pair) return { start: null, end: null };
  console.log(
    `🎮 Random game: par ${pair.path.length - 1} (${pair.start} → ${pair.end})`,
  );
  return { start: pair.start, end: pair.end };
};

export interface PotentialRarestMove {
  word: string;
  frequency: number;
  playerChoseThisRarestOption: boolean;
}

/** Path overlays. Keys are persisted (Ruling R6). */
export interface PathDisplayMode {
  player: boolean;
  /** The gold path overlay. */
  optimal: boolean;
  /** The Local Optimal route overlay (from the current word). */
  suggested: boolean;
  /** AI solution path (dailies: the gold path, model "deterministic"). */
  ai: boolean;
}
